if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"vendors-node_modules_mui_icons-material_ChevronRight_js-node_modules_mui_icons-material_esm_A-5acc8f":1,"src_components_Country_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_slic-20bdea":1,"src_components_RegionInfo_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_s-2921c5":1,"src_components_ActivityInfo_js-node_modules_react-i18next_dist_es_useTranslation_js-node_modu-debb4a":1,"vendors-node_modules_video_js_dist_video-js_css":1,"vendors-node_modules_react-pdf-viewer_core_lib_index_js-node_modules_mui_material_Divider_Div-2098e3":1,"src_pages_ItinerariesPageDefault_js-node_modules_slick-carousel_slick_slick-theme_css-node_mo-a33cd4":1,"src_pages_ItinerariesPageJacada_js-node_modules_slick-carousel_slick_slick-theme_css-node_mod-1b3c67":1,"src_pages_ItinerariesPageYellowZebra_js-common_components_Modals_BaseModal_js-node_modules_sl-a078b0":1,"src_pages_ItinerariesPageWilderness2_js-common_components_Modals_BaseModal_js-node_modules_sl-bc5575":1,"src_components_landing_common_WatchVideoButton_js-src_pages_ItinerariesPageWilderness_js-comm-4b91f4":1,"src_utils_Itineraries_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_slick-b5fc010":1,"src_pages_ItineraryPageYellowZebra_js-src_utils_Itineraries_js-node_modules_slick-carousel_sl-991c44":1,"src_utils_Itineraries_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_slick-b5fc011":1,"src_utils_Itineraries_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_slick-b5fc012":1,"common_hooks_user_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_slick-car-0f72c40":1,"src_pages_ItineraryPageYellowZebra_js-common_hooks_user_js-node_modules_slick-carousel_slick_-cf8913":1,"common_hooks_user_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_slick-car-0f72c41":1,"common_hooks_user_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_slick-car-0f72c42":1,"src_pages_QuestionsPageWilderness2_js-node_modules_slick-carousel_slick_slick-theme_css-node_-f2ba00":1,"src_pages_CampPageWilderness2_js-node_modules_slick-carousel_slick_slick-theme_css-node_modul-cbe82b":1,"src_pages_CampPageDefault_js-node_modules_slick-carousel_slick_slick-theme_css-node_modules_s-c9158a":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded